module.exports = __webpack_public_path__ + "static/media/10.3dc9955c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/10.svg
// module id = 122
// module chunks = 0